import { useTranslation } from "react-i18next";

const KEYS = ["intro", "types", "consent", "tools", "control", "retention", "contact"];

export default function Cookies({ onReopenCookies }) {
  const { t } = useTranslation();
  return (
    <article className="legal-page" data-testid="cookies-page">
      <div className="legal-inner">
        <span className="eyebrow">{t("nav.legal")}</span>
        <h1 className="h-display legal-title">{t("cookiesPage.title")}</h1>
        <p className="legal-updated">{t("cookiesPage.updated")}</p>
        {KEYS.map((k) => (
          <section className="legal-section" key={k}>
            <h2 className="legal-h2">{t(`cookiesPage.${k}Title`)}</h2>
            <p className="legal-body">{t(`cookiesPage.${k}Text`)}</p>
          </section>
        ))}
        <div className="legal-action">
          <button type="button" className="btn btn-solid" onClick={onReopenCookies} data-testid="cookies-reopen">
            {t("cookiesPage.reopenButton")}
          </button>
        </div>
      </div>
    </article>
  );
}
